/**
 * Connector Correlation Service
 * Service for connector interface
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EntitlementConsentDto } from './entitlement-consent-dto';
import { PaybackMembershipAliasDto } from './payback-membership-alias-dto';


export interface PaybackMembershipDto { 
    /**
     * Business membership identifier (stable per program; same as integration path membership_reference)
     */
    paybackMembershipId: string;
    /**
     * Program identifier
     */
    program: string;
    /**
     * Convercus account ID linked to this membership
     */
    accountId?: object | null;
    /**
     * Program membership ID
     */
    membershipId?: object | null;
    /**
     * Current membership status
     */
    status: PaybackMembershipDto.StatusEnum;
    /**
     * Document version for optimistic locking
     */
    version: number;
    /**
     * Short name of the partner associated with the membership
     */
    partnerShortName: string;
    /**
     * List of membership aliases (e.g. card numbers, external IDs)
     */
    identifiers?: Array<PaybackMembershipAliasDto> | null;
    /**
     * Entitlement consents for the membership
     */
    entitlementConsents?: Array<EntitlementConsentDto> | null;
    /**
     * Timestamp of last change (ISO 8601)
     */
    lastChangedAt: string;
    /**
     * Type of the last event that changed the membership
     */
    lastEventType: string;
    /**
     * Map of event names to their effective dates (ISO 8601)
     */
    lastEventEffectiveDates: { [key: string]: string; };
}
export namespace PaybackMembershipDto {
    export type StatusEnum = 'PENDING' | 'LINKED' | 'UNLINKED';
    export const StatusEnum = {
        Pending: 'PENDING' as StatusEnum,
        Linked: 'LINKED' as StatusEnum,
        Unlinked: 'UNLINKED' as StatusEnum
    };
}


